exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-group, .btn-group-vertical {\r\n    width: 100%;\r\n}\r\n\r\n.btn-square {\r\n    font-size: 1.5em;\r\n    height: 33vw;\r\n    margin-top: 1em;\r\n}\r\n\r\n.col-form-label {\r\n    text-align: right;\r\n}\r\n\r\n.input-group>.input-group-append>.input-group-text {\r\n    min-width: 3em;\r\n}\r\n\r\n.input-group>.input-group-prepend>.input-group-text {\r\n    min-width: 6em;\r\n}\r\n", ""]);

// exports
